import PersonContactTableColumn from "../../constants/PersonContactTableColumn";

export default [
    {id: PersonContactTableColumn.NAME.key, active: true},
    {id: PersonContactTableColumn.EMAIL.key, active: true},
    {id: PersonContactTableColumn.PHONE_NUMBER.key, active: true},
    {id: PersonContactTableColumn.TAGS.key, active: true},
    {id: PersonContactTableColumn.ORGANIZATION_CONTACTS.key, active:true}
]